import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { initialAppState } from './models/reduxState';
import { reducers } from './rootReducer';

const createdStore = createStore(reducers, initialAppState, composeWithDevTools(applyMiddleware(thunk)));
export const store = createdStore;
